export default {"src":"/_next/static/media/personal-relations.3b43e0b9.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};